import { render, staticRenderFns } from "./GenerateAvatarButton.vue?vue&type=template&id=a925ae64&scoped=true"
import script from "./GenerateAvatarButton.vue?vue&type=script&lang=ts"
export * from "./GenerateAvatarButton.vue?vue&type=script&lang=ts"
import style0 from "./GenerateAvatarButton.vue?vue&type=style&index=0&id=a925ae64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a925ae64",
  null
  
)

export default component.exports